<!-- 方形确认框 -->
<template>
  <van-dialog
    v-model="showDialog"
    :showConfirmButton="false"
    :close-on-click-overlay="isClickClose"
    :class="direction ? 'directionDegrees' : ''"
  >
    <div class="TitleBox">
      <div class="deleteTitle">{{ title }}</div>
      <img src="@/assets/icons/x.png" alt="" @click="closeDialog" />
    </div>
    <div class="hintText">{{ content }}</div>
    <div class="deleteOperate">
      <button class="button deleteCancel" @click="closeDialog">取消</button>
      <button class="button deleteAffirm" @click="affirm">确认</button>
    </div>
  </van-dialog>
</template>
      <script>
export default {
  name: "SecondConfirm",
  components: {},
  model: {
    prop: "showDialog",
    event: "change",
  },
  props: {
    // 弹框的显示隐藏
    showDialog: {
      type: Boolean,
      default: false,
    },
    // 是否点击遮罩隐藏弹窗
    isClickClose: {
      type: Boolean,
      default: false,
    },
    // 标题
    title: {
      type: String,
      default: "提示",
    },
    // 标题
    content: {
      type: String,
      default: "",
    },
    // 是否选择90度
    direction: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {
    affirm() {
      this.$emit("affirm", false);
    },
    closeDialog() {
      this.$emit("update:showDialog", false);
    },
  },
};
</script>
      <style lang="less" scoped>
.button {
  border: none;
  background: none;
}
.TitleBox {
  position: relative;
  img {
    width: 16px;
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translate(-50%, -50%);
  }
  .deleteTitle {
    font-size: 16px;
    font-weight: 400;
    color: #000;
    margin-top: 16px;
  }
}

.hintText {
  font-size: 14px;
  font-weight: 400;
  color: #666;
  margin-top: 26px;
  padding: 0 24px;
}
.deleteOperate {
  margin: 38px auto 20px auto;
  .deleteCancel {
    width: 116px;
    height: 40px;
    background: #edeff3;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #9b9b9b;
    margin-right: 16px;
    line-height: 40px;
  }
  .deleteAffirm {
    width: 116px;
    height: 40px;
    background: #886df3;
    border-radius: 4px;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 40px;
  }
  .machineAffirm {
    width: 25%;
    height: 34px;
    background: #886df3;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    line-height: 30px;
    margin-left: 12px;
  }
  .gram {
    background: #aaacb5;
  }
}
.directionDegrees {
  transform: rotate(90deg) translate3d(-50%, -50%, 0);
  transform-origin: 0px 0px;
}
</style>
      